var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["examination-settings-panel", `${_vm.configs.client}`] },
    [
      _c("div", { staticClass: "tabs-wrap" }),
      _vm._v(" "),
      _c(
        "vh-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "vh-tab-pane",
            { attrs: { label: _vm.$t("lang.k_893001"), name: "whole" } },
            [
              _c(
                "div",
                { staticClass: "tab-content tab-panel" },
                [
                  !_vm.configs.is_watch_jssdk
                    ? [
                        _c(
                          "section",
                          { staticClass: "set-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-between" },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.$t("lang.k_893002"))),
                                ]),
                                _vm._v(" "),
                                _c("vh-switch", {
                                  attrs: {
                                    size: "mini",
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: _vm.changeAnswerConditionSwitch,
                                  },
                                  model: {
                                    value: _vm.qData.answer_condition.type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.qData.answer_condition,
                                        "type",
                                        $$v
                                      )
                                    },
                                    expression: "qData.answer_condition.type",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "limit-tip" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.qData.answer_condition.type == 1
                                      ? _vm.$t("lang.k_893003")
                                      : _vm.$t("lang.k_893004")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.qData.answer_condition.type
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "answer_condition" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("lang.k_893005"))),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "vh-select",
                                        {
                                          attrs: { size: "mini" },
                                          model: {
                                            value:
                                              _vm.qData.answer_condition
                                                .viewing_minutes,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.qData.answer_condition,
                                                "viewing_minutes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "qData.answer_condition.viewing_minutes",
                                          },
                                        },
                                        _vm._l(16, function (n) {
                                          return _c("vh-option", {
                                            key: n,
                                            attrs: {
                                              label:
                                                n * 5 + _vm.$t("lang.k_893006"),
                                              value: n * 5,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("lang.k_893007"))),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "limit-tip" }, [
                                    _vm._v(_vm._s(_vm.$t("lang.k_893008"))),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("section", { staticClass: "set-item" }, [
                          _c(
                            "div",
                            { staticClass: "flex-between" },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("lang.k_893009"))),
                              ]),
                              _vm._v(" "),
                              _c("vh-switch", {
                                attrs: {
                                  size: "mini",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                on: { change: _vm.changeReAnswer },
                                model: {
                                  value: _vm.qData.can_re_answer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.qData, "can_re_answer", $$v)
                                  },
                                  expression: "qData.can_re_answer",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "limit-tip" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.qData.can_re_answer == 1
                                    ? _vm.$t("lang.k_893010")
                                    : _vm.$t("lang.k_893011")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("section", { staticClass: "set-item" }, [
                          _c(
                            "div",
                            { staticClass: "flex-between" },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("lang.k_893012"))),
                              ]),
                              _vm._v(" "),
                              _c("vh-switch", {
                                attrs: {
                                  size: "mini",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.qData.mandatory_filling,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qData,
                                      "mandatory_filling",
                                      $$v
                                    )
                                  },
                                  expression: "qData.mandatory_filling",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "limit-tip" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.qData.mandatory_filling == 1
                                    ? _vm.$t("lang.k_893013")
                                    : _vm.$t("lang.k_893014")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("section", { staticClass: "set-item" }, [
                          _c(
                            "div",
                            { staticClass: "flex-between" },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("lang.k_893015"))),
                              ]),
                              _vm._v(" "),
                              _c("vh-switch", {
                                attrs: {
                                  size: "mini",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                on: { change: _vm.changeReplayFilling },
                                model: {
                                  value: _vm.qData.replay_filling,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.qData, "replay_filling", $$v)
                                  },
                                  expression: "qData.replay_filling",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "limit-tip" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.qData.replay_filling == 1
                                    ? _vm.$t("lang.k_893016")
                                    : _vm.$t("lang.k_893017")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.qData.answer_condition.type && !_vm.qData.replay_filling
                    ? _c(
                        "section",
                        { staticClass: "set-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-between" },
                            [
                              _c(
                                "p",
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("lang.k_893018"))
                                  ),
                                  _c(
                                    "vh-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "bottom-end",
                                        "visible-arrow": false,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("lang.k_893019"))
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(_vm.$t("lang.k_893020")) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "vh-form-iconfont vh-form-line-question",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("vh-switch", {
                                attrs: { size: "mini" },
                                on: { change: _vm.changeLimitTime },
                                model: {
                                  value: _vm.qData.limit_time_switch,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qData,
                                      "limit_time_switch",
                                      $$v
                                    )
                                  },
                                  expression: "qData.limit_time_switch",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            _vm.qData.limit_time_switch
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "time-limit-settings" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "settings-label" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("lang.k_893021"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("vh-input-number", {
                                        staticClass: "settings-input",
                                        attrs: {
                                          placeholder:
                                            _vm.qData.limit_time_type == 1
                                              ? "5-300"
                                              : "1-60",
                                          controls: false,
                                          size: "mini",
                                          precision: 0,
                                          min:
                                            _vm.qData.limit_time_type == 1
                                              ? 5
                                              : 1,
                                          max:
                                            _vm.qData.limit_time_type == 1
                                              ? 300
                                              : 60,
                                        },
                                        on: {
                                          focus: function ($event) {
                                            _vm.oldvalue = _vm.qData.limit_time
                                          },
                                          blur: function ($event) {
                                            !_vm.qData.limit_time &&
                                              (_vm.qData.limit_time =
                                                _vm.oldvalue)
                                          },
                                        },
                                        model: {
                                          value: _vm.qData.limit_time,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.qData,
                                              "limit_time",
                                              $$v
                                            )
                                          },
                                          expression: "qData.limit_time",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "vh-select",
                                        {
                                          staticClass: "time_type",
                                          attrs: { size: "mini" },
                                          on: { change: _vm.changeTimeType },
                                          model: {
                                            value: _vm.qData.limit_time_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.qData,
                                                "limit_time_type",
                                                $$v
                                              )
                                            },
                                            expression: "qData.limit_time_type",
                                          },
                                        },
                                        [
                                          _c("vh-option", {
                                            attrs: {
                                              label: _vm.$t("lang.k_893006"),
                                              value: 0,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("vh-option", {
                                            attrs: {
                                              label: _vm.$t("lang.k_893022"),
                                              value: 1,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "limit-tip" }, [
                                    _vm._v(_vm._s(_vm.$t("lang.k_893023"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "rank-switch flex-between" },
                                    [
                                      _c(
                                        "p",
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("lang.k_893024"))
                                          ),
                                          _c(
                                            "vh-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "bottom-end",
                                                "visible-arrow": false,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("lang.k_893025")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "vh-form-iconfont vh-form-line-question",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("vh-switch", {
                                        attrs: { size: "mini" },
                                        model: {
                                          value: _vm.qData.auto_push_switch,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.qData,
                                              "auto_push_switch",
                                              $$v
                                            )
                                          },
                                          expression: "qData.auto_push_switch",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "limit-tip" }, [
                                    _vm._v(_vm._s(_vm.$t("lang.k_893026"))),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("section", { staticClass: "set-item" }, [
                    _c(
                      "div",
                      { staticClass: "flex-between display_sorce" },
                      [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("lang.k_893027"))
                            ),
                            _c(
                              "vh-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  placement: "bottom-end",
                                  "visible-arrow": false,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("lang.k_893028")))]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "vh-form-iconfont vh-form-line-question",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("vh-switch", {
                          attrs: {
                            size: "mini",
                            "active-value": 1,
                            "inactive-value": 0,
                            disabled: _vm.qData.can_re_answer == 1,
                          },
                          model: {
                            value: _vm.qData.display_score,
                            callback: function ($$v) {
                              _vm.$set(_vm.qData, "display_score", $$v)
                            },
                            expression: "qData.display_score",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "vh-tab-pane",
            {
              attrs: {
                label: _vm.$t("lang.k_893029"),
                disabled: _vm.qData.detail.length === 0,
                name: "single",
              },
            },
            [
              _vm.qData.detail[_vm.qData.curIndex]
                ? _c("div", { staticClass: "tab-panel" }, [
                    _vm.qData.detail[_vm.qData.curIndex].extension.has_img
                      ? _c(
                          "div",
                          { staticClass: "flex-start layout-settings" },
                          [
                            _c("p", { staticClass: "settings-label" }, [
                              _vm._v(_vm._s(_vm.$t("lang.k_893030"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "vh-radio-group",
                              {
                                attrs: { size: "mini" },
                                on: { change: _vm.changeImgLayout },
                                model: {
                                  value:
                                    _vm.qData.detail[_vm.qData.curIndex]
                                      .extension.img_layout,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qData.detail[_vm.qData.curIndex]
                                        .extension,
                                      "img_layout",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "qData.detail[qData.curIndex].extension.img_layout",
                                },
                              },
                              [
                                _c("vh-radio-button", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("lang.k_893031"))),
                                ]),
                                _vm._v(" "),
                                _c("vh-radio-button", { attrs: { label: 2 } }, [
                                  _vm._v(_vm._s(_vm.$t("lang.k_893032"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.qData.detail[_vm.qData.curIndex].extension.has_img
                      ? _c(
                          "div",
                          { staticClass: "flex-start layout-settings" },
                          [
                            _c("p", { staticClass: "settings-label" }, [
                              _vm._v(_vm._s(_vm.$t("lang.k_893033"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "vh-radio-group",
                              {
                                attrs: { size: "mini" },
                                model: {
                                  value:
                                    _vm.qData.detail[_vm.qData.curIndex]
                                      .extension.option_layout,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qData.detail[_vm.qData.curIndex]
                                        .extension,
                                      "option_layout",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "qData.detail[qData.curIndex].extension.option_layout",
                                },
                              },
                              [
                                _c("vh-radio-button", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("lang.k_893034"))),
                                ]),
                                _vm._v(" "),
                                _vm.qData.detail[_vm.qData.curIndex].extension
                                  .img_layout != 2
                                  ? _c(
                                      "vh-radio-button",
                                      { attrs: { label: 2 } },
                                      [_vm._v(_vm._s(_vm.$t("lang.k_893035")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "score-settings" },
                      [
                        _c("span", { staticClass: "settings-label" }, [
                          _vm._v(_vm._s(_vm.$t("lang.k_893036"))),
                        ]),
                        _vm._v(" "),
                        _c("vh-input-number", {
                          staticClass: "settings-input",
                          attrs: {
                            size: "small",
                            controls: false,
                            precision: 0,
                            min: 0,
                            max: 100,
                          },
                          model: {
                            value: _vm.qData.detail[_vm.qData.curIndex].score,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.qData.detail[_vm.qData.curIndex],
                                "score",
                                $$v
                              )
                            },
                            expression: "qData.detail[qData.curIndex].score",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("lang.k_893037")))]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.qData.detail[_vm.qData.curIndex].type === "radio"
                      ? _c(
                          "div",
                          { staticClass: "answer-container" },
                          [
                            _c("p", { staticClass: "settings-label" }, [
                              _vm._v(_vm._s(_vm.$t("lang.k_893038"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "vh-radio-group",
                              {
                                staticClass: "option-wrap",
                                on: { change: _vm.setCurrentAnswer },
                                model: {
                                  value:
                                    _vm.qData.detail[_vm.qData.curIndex]
                                      .correct_answer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qData.detail[_vm.qData.curIndex],
                                      "correct_answer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "qData.detail[qData.curIndex].correct_answer",
                                },
                              },
                              _vm._l(
                                _vm.qData.detail[_vm.qData.curIndex].detail
                                  .list,
                                function (option) {
                                  return _c(
                                    "vh-radio",
                                    {
                                      key: option.id || option.kid,
                                      staticClass: "option-item",
                                      attrs: { label: option.key },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("overHidden")(
                                            option.key + "." + option.value,
                                            16
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.qData.detail[_vm.qData.curIndex].type === "checkbox"
                      ? _c(
                          "div",
                          { staticClass: "answer-container" },
                          [
                            _c("p", { staticClass: "settings-label" }, [
                              _vm._v(_vm._s(_vm.$t("lang.k_893039"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "vh-checkbox-group",
                              {
                                staticClass: "option-wrap",
                                attrs: { directionVertical: "" },
                                on: { change: _vm.setCurrentAnswer },
                                model: {
                                  value:
                                    _vm.qData.detail[_vm.qData.curIndex]
                                      .correct_answer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qData.detail[_vm.qData.curIndex],
                                      "correct_answer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "qData.detail[qData.curIndex].correct_answer",
                                },
                              },
                              _vm._l(
                                _vm.qData.detail[_vm.qData.curIndex].detail
                                  .list,
                                function (option) {
                                  return _c(
                                    "vh-checkbox",
                                    {
                                      key: option.id,
                                      staticClass: "option-item",
                                      attrs: { label: option.key },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("overHidden")(
                                            option.key + "." + option.value,
                                            16
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }